// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".toggle_alignment{display:grid;grid-template-columns:1fr 20%}", "",{"version":3,"sources":["webpack://./src/components/preferenceCard/preferenceCard.scss"],"names":[],"mappings":"AAAA,kBACE,YAAA,CACA,6BAAA","sourcesContent":[".toggle_alignment {\n  display: grid;\n  grid-template-columns: 1fr 20%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
